import { useLocation, useNavigate } from "react-router-dom";
import PaymentLayout from "../layouts/PaymentLinkLayouts";
import formatCurrency from "../../utils/numberFormatter";
import { getErrorMessage } from "../../utils/paymentLinkErrorHandler";
import RedirectCountdown from "../components/RedirectCountdown";

export default function PaymentLinkExpired() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    selectedMethod,
    reffNo,
    amount,
    errorCode,
    message,
    title,
    redirectUrl
  } = location.state || {};

  // Use error handler utility to get appropriate message
  const displayTitle = title || "Payment Link Expired";
  const displayMessage = errorCode
    ? getErrorMessage(errorCode)
    : message || "This payment link is no longer valid. Please request a new one if needed.";


  return (
    <PaymentLayout title={displayTitle}>
      {amount && (
        <div>
          <h2 className="text-4xl font-bold">{formatCurrency(amount).split(",")[0]}</h2>
          {reffNo && <p className="text-gray-600 mt-2">Reff No. {reffNo}</p>}
          {selectedMethod && <div className="text-gray-600">Method: {selectedMethod}</div>}
        </div>
      )}

      <div className="bg-gray-50 p-4 rounded-lg text-center mt-4">
        <h2 className="text-2xl font-bold text-red-600">{displayTitle}</h2>
        <p className="text-gray-700">{displayMessage}</p>
      </div>

      <RedirectCountdown redirectUrl={redirectUrl} />
    </PaymentLayout>
  );
}
